import React from 'react';
import styled from 'styled-components';
import { device } from '../../constants';

interface Props {
  onClick: () => void;
}

const BurgerButton = ({ onClick }: Props) => {
  return (
    <StyledBurger onClick={onClick}>
      <span />
      <span />
      <span />
    </StyledBurger>
  );
};
const StyledBurger = styled.button`
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  @media ${device.md} {
    display: flex;
  }

  span {
    display: block;
    width: 100%;
    height: 3px;
    background-color: #333;
    border-radius: 2px;
  }
`;
export default BurgerButton;
